import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App.js';

// Global reset styles
const style = document.createElement('style');
style.textContent = `
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  html, body { height: 100%; overflow: hidden; }
  #root { height: 100%; }
  input, button, select, textarea { font: inherit; }
  /* Prevent double-tap zoom on tablets */
  button, a { touch-action: manipulation; }
`;
document.head.appendChild(style);

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
